import { z } from 'zod'

export const ItemCreateSchema = z.object({
  code: z.string(),
  name: z.string(),
  canBePurchased: z.boolean().default(false),
  canBeManufactured: z.boolean().default(false),
  canBeUsedInBom: z.boolean().default(false),
  canBeSold: z.boolean().default(false),
  isMoldTracking: z.boolean().default(false),
  isLotTracking: z.boolean().default(false),
  unit: z.string().max(20).default('pcs'),
  type: z.string().max(15).optional(),
  weight: z.number().default(0),
  category: z.string().max(40).optional(),
})

export type ItemCreateModel = z.infer<typeof ItemCreateSchema>

export const ItemUpdateSchema = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
  canBePurchased: z.boolean().default(false),
  canBeManufactured: z.boolean().default(false),
  canBeUsedInBom: z.boolean().default(false),
  canBeSold: z.boolean().default(false),
  isMoldTracking: z.boolean().default(false),
  isLotTracking: z.boolean().default(false),
  unit: z.string().max(20).default('pcs'),
  weight: z.number().default(0),
  type: z.string().nullable(),
  category: z.string().nullable(),
})

export type ItemUpdateModel = z.infer<typeof ItemUpdateSchema>

export const ItemBomCreateSchema = z.object({
  isDefault: z.boolean().default(true),
  items: z
    .array(
      z.object({ seq: z.number(), itemId: z.string(), qty: z.number().min(1) })
    )
    .min(1, { message: 'กรุณาระบุ item' }),
})

export type ItemBomCreateModel = z.infer<typeof ItemBomCreateSchema>

export const ItemBomUpdateSchema = z.object({
  isDefault: z.boolean().default(true),
  items: z
    .array(
      z.object({
        seq: z.number(),
        itemId: z.string(),
        qty: z.number(),
      })
    )
    .min(1, { message: 'กรุณาระบุ item' }),
})

export type ItemBomUpdateModel = z.infer<typeof ItemBomUpdateSchema>
